import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { TherapistAction } from 'src/redux/actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

function* editTaskTime(action: any): SagaReturnType<any> {
  try {
    const response = yield call(therapistSchedulingServices.editTaskTime, action.payload);
    if (response?.status === 200) {
      yield put({
        type: TherapistAction.EDIT_TASK_SUCCESS,
        payload: response.data,
        isAssigned: action.payload?.isAssigned,
        suppressSuccessMessage: action.payload?.suppressSuccessMessage || false,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    const taskIds = action?.payload?.taskId;
    yield put({
      type: TherapistAction.EDIT_TASK_FAILURE,
      payload: error,
      requestPayload: {
        providerId: action?.payload?.providerId,
        taskUuid: Array.isArray(taskIds) ? taskIds[0] : taskIds,
        time: action?.payload?.time,
      },
    });
  }
}

function* editTaskTimeSaga() {
  yield takeEvery(TherapistAction.EDIT_TASK_REQUEST, editTaskTime);
}

export default editTaskTimeSaga;
